import { h, ComponentChildren } from 'preact';
import Navbar from './Navbar';

interface MainLayoutProps {
  children: ComponentChildren;
}

export default function MainLayout({ children }: MainLayoutProps) {
  return (
    <div class="min-h-screen bg-gray-50">
      <Navbar />
      <main class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
    </div>
  );
}
